export const roundRate2 = (value) => {
  return Math.round((parseFloat(value) || 0) * 100) / 100;
};

export const exclusiveToInclusive = (srate, taxPct) => {
  const rate = parseFloat(srate) || 0;
  const tax = parseFloat(taxPct) || 0;
  return roundRate2(rate * (1 + tax / 100));
};

export const inclusiveToExclusive = (srateIncl, taxPct) => {
  const incl = parseFloat(srateIncl) || 0;
  const tax = parseFloat(taxPct) || 0;
  if (tax === 0) return roundRate2(incl);
  return roundRate2(incl / (1 + tax / 100));
};

export const calculateItemPercentageDiscountAmount = (
  srate,
  directDiscount,
  discountPercentage
) => {
  const rate = parseFloat(srate) || 0;
  const direct = parseFloat(directDiscount) || 0;
  const percentage = parseFloat(discountPercentage) || 0;
  const discountBase = Math.max(rate - direct, 0);

  return roundRate2((discountBase * percentage) / 100);
};

export const getItemSecondDiscountAmount = (row) => {
  const percentage = parseFloat(row?.dis2perc) || 0;

  if (percentage > 0) {
    return calculateItemPercentageDiscountAmount(
      row?.srate,
      row?.dis1,
      percentage
    );
  }

  return parseFloat(row?.dis2) || 0;
};

export const getItemNetRate = (row) => {
  const rate = parseFloat(row?.srate) || 0;
  const directDiscount = parseFloat(row?.dis1) || 0;
  const percentageDiscount = getItemSecondDiscountAmount(row);

  return Math.max(roundRate2(rate - directDiscount - percentageDiscount), 0);
};

export const withRecalculatedItemPercentageDiscount = (row) => {
  const percentage = parseFloat(row?.dis2perc) || 0;
  if (percentage <= 0) return row;

  return {
    ...row,
    dis2: calculateItemPercentageDiscountAmount(
      row.srate,
      row.dis1,
      percentage
    ),
  };
};

export const withItemDirectDiscount = (row, directDiscount) =>
  withRecalculatedItemPercentageDiscount({
    ...row,
    dis1: parseFloat(directDiscount) || 0,
  });

export const withItemDiscountPercentage = (row, discountPercentage) => {
  const percentage = Math.min(
    Math.max(parseFloat(discountPercentage) || 0, 0),
    99
  );

  return {
    ...row,
    dis2perc: percentage,
    dis2:
      percentage > 0
        ? calculateItemPercentageDiscountAmount(
            row.srate,
            row.dis1,
            percentage
          )
        : 0,
  };
};

export const withSyncedRatesFromExclusive = (row, srate) => {
  const nextRate = srate;
  return withRecalculatedItemPercentageDiscount({
    ...row,
    srate: nextRate,
    srate_incl: exclusiveToInclusive(nextRate, row.tax),
  });
};

export const withSyncedRatesFromInclusive = (row, srateIncl) => {
  const nextIncl = srateIncl;
  return withRecalculatedItemPercentageDiscount({
    ...row,
    srate_incl: nextIncl,
    srate: inclusiveToExclusive(nextIncl, row.tax),
  });
};
